/**
 * @module Template-Header-Style-2
 */

import { NavLink, useLocation } from "react-router-dom";
import { loadScript, navUrl } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { useEffect, useState } from "react";
import AvertImage from "../../../../globals/elements/avertimg";
import SectionHeaderNavMenu from "../navigation/nav-menu";

/**
 * 
 * @returns Markup for Header Style 2 for template
 */
const SectionHeader2 = () => {

    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const location = useLocation();

    const toggleNavDrawer = () => {
        setIsDrawerVisible(!isDrawerVisible);
    }

    // Close the menu when the route changes
    useEffect(() => {
        setIsDrawerVisible(false);
    }, [location.pathname]);

    // Determine which logo to use based on current page
    const isHomepage = location.pathname === route.INITIAL;
    
    // Check if we're showing homepage content (including catch-all routes)
    const isShowingHomepage = isHomepage || 
        (location.pathname !== route.INITIAL && 
         !location.pathname.startsWith('/about-us') &&
         !location.pathname.startsWith('/contact-us') &&
         !location.pathname.startsWith('/our-team') &&
         !location.pathname.startsWith('/faq') &&
         !location.pathname.startsWith('/success-stories') &&
         !location.pathname.startsWith('/blog') &&
         !location.pathname.startsWith('/privacy-policy') &&
         !location.pathname.startsWith('/terms-of-service') &&
         !location.pathname.startsWith('/cookie-policy') &&
         !location.pathname.startsWith('/acceptable-use-policy') &&
         !location.pathname.startsWith('/data-breach-policy') &&
         !location.pathname.startsWith('/business-continuity-policy') &&
         !location.pathname.startsWith('/employee-code-of-conduct') &&
         !location.pathname.startsWith('/services') &&
         !location.pathname.startsWith('/blogs'));
    
    const logoSrc = isShowingHomepage ? "images/logos/logo-anathoth-white.svg" : "images/logos/logo-anathoth.svg";

    useEffect(()=>{
        loadScript("js/nav-menu.js");
    })
    
    return (
        <header className={"site-header header-style-2 hdr-full mobile-sider-drawer-menu "+(isDrawerVisible?'active':'') + (!isShowingHomepage ? ' non-homepage' : '')} 
                style={!isShowingHomepage ? { background: 'linear-gradient(to bottom, #f6f7ff 0%, rgba(246, 247, 255, 0.8) 70%, rgba(246, 247, 255, 0.3) 100%)' } : {}}>
            <div className="header-style-2-content">
                <div className="header-middle-wraper ">
                    <div className="container">
                        <div className="header-middle d-flex justify-content-between align-items-center">
                            <div className="logo-header">
                                <div className="logo-header-inner logo-header-one">
                                    <NavLink to={route.INITIAL}>
                                        <AvertImage src={logoSrc} alt="Anathoth Technologies Ltd" />
                                    </NavLink>
                                </div>
                            </div>
                            <div className=" main-bar-wraper  navbar-expand-lg">
                                <div className="main-bar header-bottom">
                                    <div className="container-block clearfix">
                                        <div className="navigation-bar">
                                            {/* NAV Toggle Button */}
                                            <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" type="button" className={"navbar-toggler collapsed" + (isHomepage ? " homepage" : "")}
                                            onClick={toggleNavDrawer}>
                                                <span className="sr-only">Toggle navigation</span>
                                                <span className="icon-bar icon-bar-first" />
                                                <span className="icon-bar icon-bar-two" />
                                                <span className="icon-bar icon-bar-three" />
                                            </button>
                                            {/* MAIN Vav */}
                                            <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-between">
                                                <SectionHeaderNavMenu />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Header Right Section*/}
                            <div className="extra-nav header-1-nav">
                                <div className="extra-cell one">
                                    <div className="header-info">
                                        <ul>
                                            <li>
                                                <div className="twm-icon-box-wraper">
                                                    <div className="twm-icon-box" />
                                                    <div className="twm-icon-box-content">
                                                        <p>Phone Number</p>
                                                        <h3 className="twm-tilte"><a href="tel:+256744666608">+256 (744) 666608</a></h3>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="extra-cell two">
                                    <NavLink to={navUrl.pages(route.pages.CONTACT)} className="site-button">Meet With Us <i className="fa fa-plus" /> </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}
export default SectionHeader2;